import { render } from "./SaicaList.component.vue?vue&type=template&id=1f9204dc&scoped=true&ts=true"
import script from "./SaicaList.component.vue?vue&type=script&lang=ts"
export * from "./SaicaList.component.vue?vue&type=script&lang=ts"

import "./SaicaList.component.vue?vue&type=style&index=0&id=1f9204dc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9204dc"]])

export default __exports__